export const blogTranslations = {
  BLOG_TITLE: 'Inspiratie',
  BLOG_SUBTITLE: 'Lees, leer en raak geïnspireerd!'
}
